export default __webpack_public_path__ + "static/media/openDoc.cfe816e0.svg";